import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createLexer } from 'leac';
import * as p from 'peberminta';
var ast = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var ws = "(?:[ \\t\\r\\n\\f]*)";
var nl = "(?:\\n|\\r\\n|\\r|\\f)";
var nonascii = "[^\\x00-\\x7F]";
var unicode = "(?:\\\\[0-9a-f]{1,6}(?:\\r\\n|[ \\n\\r\\t\\f])?)";
var escape = "(?:\\\\[^\\n\\r\\f0-9a-f])";
var nmstart = "(?:[_a-z]|".concat(nonascii, "|").concat(unicode, "|").concat(escape, ")");
var nmchar = "(?:[_a-z0-9-]|".concat(nonascii, "|").concat(unicode, "|").concat(escape, ")");
var name = "(?:".concat(nmchar, "+)");
var ident = "(?:[-]?".concat(nmstart).concat(nmchar, "*)");
var string1 = "'([^\\n\\r\\f\\\\']|\\\\".concat(nl, "|").concat(nonascii, "|").concat(unicode, "|").concat(escape, ")*'");
var string2 = "\"([^\\n\\r\\f\\\\\"]|\\\\".concat(nl, "|").concat(nonascii, "|").concat(unicode, "|").concat(escape, ")*\"");
var lexSelector = createLexer([{
  name: 'ws',
  regex: new RegExp(ws)
}, {
  name: 'hash',
  regex: new RegExp("#".concat(name), 'i')
}, {
  name: 'ident',
  regex: new RegExp(ident, 'i')
}, {
  name: 'str1',
  regex: new RegExp(string1, 'i')
}, {
  name: 'str2',
  regex: new RegExp(string2, 'i')
}, {
  name: '*'
}, {
  name: '.'
}, {
  name: ','
}, {
  name: '['
}, {
  name: ']'
}, {
  name: '='
}, {
  name: '>'
}, {
  name: '|'
}, {
  name: '+'
}, {
  name: '~'
}, {
  name: '^'
}, {
  name: '$'
}]);
var lexEscapedString = createLexer([{
  name: 'unicode',
  regex: new RegExp(unicode, 'i')
}, {
  name: 'escape',
  regex: new RegExp(escape, 'i')
}, {
  name: 'any',
  regex: new RegExp('[\\s\\S]', 'i')
}]);
function sumSpec(_ref, _ref2) {
  var _ref3 = _slicedToArray(_ref, 3),
    a0 = _ref3[0],
    a1 = _ref3[1],
    a2 = _ref3[2];
  var _ref4 = _slicedToArray(_ref2, 3),
    b0 = _ref4[0],
    b1 = _ref4[1],
    b2 = _ref4[2];
  return [a0 + b0, a1 + b1, a2 + b2];
}
function sumAllSpec(ss) {
  return ss.reduce(sumSpec, [0, 0, 0]);
}
var unicodeEscapedSequence_ = p.token(function (t) {
  return t.name === 'unicode' ? String.fromCodePoint(parseInt(t.text.slice(1), 16)) : undefined;
});
var escapedSequence_ = p.token(function (t) {
  return t.name === 'escape' ? t.text.slice(1) : undefined;
});
var anyChar_ = p.token(function (t) {
  return t.name === 'any' ? t.text : undefined;
});
var escapedString_ = p.map(p.many(p.or(unicodeEscapedSequence_, escapedSequence_, anyChar_)), function (cs) {
  return cs.join('');
});
function unescape(escapedString) {
  var lexerResult = lexEscapedString(escapedString);
  var result = escapedString_({
    tokens: lexerResult.tokens,
    options: undefined
  }, 0);
  return result.value;
}
function literal(name) {
  return p.token(function (t) {
    return t.name === name ? true : undefined;
  });
}
var whitespace_ = p.token(function (t) {
  return t.name === 'ws' ? null : undefined;
});
var optionalWhitespace_ = p.option(whitespace_, null);
function optionallySpaced(parser) {
  return p.middle(optionalWhitespace_, parser, optionalWhitespace_);
}
var identifier_ = p.token(function (t) {
  return t.name === 'ident' ? unescape(t.text) : undefined;
});
var hashId_ = p.token(function (t) {
  return t.name === 'hash' ? unescape(t.text.slice(1)) : undefined;
});
var string_ = p.token(function (t) {
  return t.name.startsWith('str') ? unescape(t.text.slice(1, -1)) : undefined;
});
var namespace_ = p.left(p.option(identifier_, ''), literal('|'));
var qualifiedName_ = p.eitherOr(p.ab(namespace_, identifier_, function (ns, name) {
  return {
    name: name,
    namespace: ns
  };
}), p.map(identifier_, function (name) {
  return {
    name: name,
    namespace: null
  };
}));
var uniSelector_ = p.eitherOr(p.ab(namespace_, literal('*'), function (ns) {
  return {
    type: 'universal',
    namespace: ns,
    specificity: [0, 0, 0]
  };
}), p.map(literal('*'), function () {
  return {
    type: 'universal',
    namespace: null,
    specificity: [0, 0, 0]
  };
}));
var tagSelector_ = p.map(qualifiedName_, function (_ref5) {
  var name = _ref5.name,
    namespace = _ref5.namespace;
  return {
    type: 'tag',
    name: name,
    namespace: namespace,
    specificity: [0, 0, 1]
  };
});
var classSelector_ = p.ab(literal('.'), identifier_, function (fullstop, name) {
  return {
    type: 'class',
    name: name,
    specificity: [0, 1, 0]
  };
});
var idSelector_ = p.map(hashId_, function (name) {
  return {
    type: 'id',
    name: name,
    specificity: [1, 0, 0]
  };
});
var attrModifier_ = p.token(function (t) {
  if (t.name === 'ident') {
    if (t.text === 'i' || t.text === 'I') {
      return 'i';
    }
    if (t.text === 's' || t.text === 'S') {
      return 's';
    }
  }
  return undefined;
});
var attrValue_ = p.eitherOr(p.ab(string_, p.option(p.right(optionalWhitespace_, attrModifier_), null), function (v, mod) {
  return {
    value: v,
    modifier: mod
  };
}), p.ab(identifier_, p.option(p.right(whitespace_, attrModifier_), null), function (v, mod) {
  return {
    value: v,
    modifier: mod
  };
}));
var attrMatcher_ = p.choice(p.map(literal('='), function () {
  return '=';
}), p.ab(literal('~'), literal('='), function () {
  return '~=';
}), p.ab(literal('|'), literal('='), function () {
  return '|=';
}), p.ab(literal('^'), literal('='), function () {
  return '^=';
}), p.ab(literal('$'), literal('='), function () {
  return '$=';
}), p.ab(literal('*'), literal('='), function () {
  return '*=';
}));
var attrPresenceSelector_ = p.abc(literal('['), optionallySpaced(qualifiedName_), literal(']'), function (lbr, _ref6) {
  var name = _ref6.name,
    namespace = _ref6.namespace;
  return {
    type: 'attrPresence',
    name: name,
    namespace: namespace,
    specificity: [0, 1, 0]
  };
});
var attrValueSelector_ = p.middle(literal('['), p.abc(optionallySpaced(qualifiedName_), attrMatcher_, optionallySpaced(attrValue_), function (_ref7, matcher, _ref8) {
  var name = _ref7.name,
    namespace = _ref7.namespace;
  var value = _ref8.value,
    modifier = _ref8.modifier;
  return {
    type: 'attrValue',
    name: name,
    namespace: namespace,
    matcher: matcher,
    value: value,
    modifier: modifier,
    specificity: [0, 1, 0]
  };
}), literal(']'));
var attrSelector_ = p.eitherOr(attrPresenceSelector_, attrValueSelector_);
var typeSelector_ = p.eitherOr(uniSelector_, tagSelector_);
var subclassSelector_ = p.choice(idSelector_, classSelector_, attrSelector_);
var compoundSelector_ = p.map(p.eitherOr(p.flatten(typeSelector_, p.many(subclassSelector_)), p.many1(subclassSelector_)), function (ss) {
  return {
    type: 'compound',
    list: ss,
    specificity: sumAllSpec(ss.map(function (s) {
      return s.specificity;
    }))
  };
});
var combinator_ = p.choice(p.map(literal('>'), function () {
  return '>';
}), p.map(literal('+'), function () {
  return '+';
}), p.map(literal('~'), function () {
  return '~';
}), p.ab(literal('|'), literal('|'), function () {
  return '||';
}));
var combinatorSeparator_ = p.eitherOr(optionallySpaced(combinator_), p.map(whitespace_, function () {
  return ' ';
}));
var complexSelector_ = p.leftAssoc2(compoundSelector_, p.map(combinatorSeparator_, function (c) {
  return function (left, right) {
    return {
      type: 'compound',
      list: [].concat(_toConsumableArray(right.list), [{
        type: 'combinator',
        combinator: c,
        left: left,
        specificity: left.specificity
      }]),
      specificity: sumSpec(left.specificity, right.specificity)
    };
  };
}), compoundSelector_);
var listSelector_ = p.leftAssoc2(p.map(complexSelector_, function (s) {
  return {
    type: 'list',
    list: [s]
  };
}), p.map(optionallySpaced(literal(',')), function () {
  return function (acc, next) {
    return {
      type: 'list',
      list: [].concat(_toConsumableArray(acc.list), [next])
    };
  };
}), complexSelector_);
function parse_(parser, str) {
  if (!(typeof str === 'string' || str instanceof String)) {
    throw new Error('Expected a selector string. Actual input is not a string!');
  }
  var lexerResult = lexSelector(str);
  if (!lexerResult.complete) {
    throw new Error("The input \"".concat(str, "\" was only partially tokenized, stopped at offset ").concat(lexerResult.offset, "!\n") + prettyPrintPosition(str, lexerResult.offset));
  }
  var result = optionallySpaced(parser)({
    tokens: lexerResult.tokens,
    options: undefined
  }, 0);
  if (!result.matched) {
    throw new Error("No match for \"".concat(str, "\" input!"));
  }
  if (result.position < lexerResult.tokens.length) {
    var token = lexerResult.tokens[result.position];
    throw new Error("The input \"".concat(str, "\" was only partially parsed, stopped at offset ").concat(token.offset, "!\n") + prettyPrintPosition(str, token.offset, token.len));
  }
  return result.value;
}
function prettyPrintPosition(str, offset) {
  var len = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return "".concat(str.replace(/(\t)|(\r)|(\n)/g, function (m, t, r) {
    return t ? "\u2409" : r ? "\u240D" : "\u240A";
  }), "\n").concat(''.padEnd(offset)).concat('^'.repeat(len));
}
function parse(str) {
  return parse_(listSelector_, str);
}
function parse1(str) {
  return parse_(complexSelector_, str);
}
function serialize(selector) {
  if (!selector.type) {
    throw new Error('This is not an AST node.');
  }
  switch (selector.type) {
    case 'universal':
      return _serNs(selector.namespace) + '*';
    case 'tag':
      return _serNs(selector.namespace) + _serIdent(selector.name);
    case 'class':
      return '.' + _serIdent(selector.name);
    case 'id':
      return '#' + _serIdent(selector.name);
    case 'attrPresence':
      return "[".concat(_serNs(selector.namespace)).concat(_serIdent(selector.name), "]");
    case 'attrValue':
      return "[".concat(_serNs(selector.namespace)).concat(_serIdent(selector.name)).concat(selector.matcher, "\"").concat(_serStr(selector.value), "\"").concat(selector.modifier ? selector.modifier : '', "]");
    case 'combinator':
      return serialize(selector.left) + selector.combinator;
    case 'compound':
      return selector.list.reduce(function (acc, node) {
        if (node.type === 'combinator') {
          return serialize(node) + acc;
        } else {
          return acc + serialize(node);
        }
      }, '');
    case 'list':
      return selector.list.map(serialize).join(',');
  }
}
function _serNs(ns) {
  return ns || ns === '' ? _serIdent(ns) + '|' : '';
}
function _codePoint(char) {
  return "\\".concat(char.codePointAt(0).toString(16), " ");
}
function _serIdent(str) {
  return str.replace(/(^[0-9])|(^-[0-9])|(^-$)|([-0-9a-zA-Z_]|[^\x00-\x7F])|(\x00)|([\x01-\x1f]|\x7f)|([\s\S])/g, function (m, d1, d2, hy, safe, nl, ctrl, other) {
    return d1 ? _codePoint(d1) : d2 ? '-' + _codePoint(d2.slice(1)) : hy ? '\\-' : safe ? safe : nl ? "\uFFFD" : ctrl ? _codePoint(ctrl) : '\\' + other;
  });
}
function _serStr(str) {
  return str.replace(/(")|(\\)|(\x00)|([\x01-\x1f]|\x7f)/g, function (m, dq, bs, nl, ctrl) {
    return dq ? '\\"' : bs ? '\\\\' : nl ? "\uFFFD" : _codePoint(ctrl);
  });
}
function normalize(selector) {
  if (!selector.type) {
    throw new Error('This is not an AST node.');
  }
  switch (selector.type) {
    case 'compound':
      {
        selector.list.forEach(normalize);
        selector.list.sort(function (a, b) {
          return _compareArrays(_getSelectorPriority(a), _getSelectorPriority(b));
        });
        break;
      }
    case 'combinator':
      {
        normalize(selector.left);
        break;
      }
    case 'list':
      {
        selector.list.forEach(normalize);
        selector.list.sort(function (a, b) {
          return serialize(a) < serialize(b) ? -1 : 1;
        });
        break;
      }
  }
  return selector;
}
function _getSelectorPriority(selector) {
  switch (selector.type) {
    case 'universal':
      return [1];
    case 'tag':
      return [1];
    case 'id':
      return [2];
    case 'class':
      return [3, selector.name];
    case 'attrPresence':
      return [4, serialize(selector)];
    case 'attrValue':
      return [5, serialize(selector)];
    case 'combinator':
      return [15, serialize(selector)];
  }
}
function compareSelectors(a, b) {
  return _compareArrays(a.specificity, b.specificity);
}
function compareSpecificity(a, b) {
  return _compareArrays(a, b);
}
function _compareArrays(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    throw new Error('Arguments must be arrays.');
  }
  var shorter = a.length < b.length ? a.length : b.length;
  for (var i = 0; i < shorter; i++) {
    if (a[i] === b[i]) {
      continue;
    }
    return a[i] < b[i] ? -1 : 1;
  }
  return a.length - b.length;
}
export { ast as Ast, compareSelectors, compareSpecificity, normalize, parse, parse1, serialize };